import { render, staticRenderFns } from "./deliverDialog.vue?vue&type=template&id=54e68cfa&scoped=true&"
import script from "./deliverDialog.vue?vue&type=script&lang=js&"
export * from "./deliverDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e68cfa",
  null
  
)

export default component.exports